<template>
  <div class="brand-lifestyle">
    <el-row class="lifestylebox">
      <el-col :span="18">
        <div class="fontstyle">
          <p class="title">ABOUT US</p>
          <p class="text">
            ORA is positioned as the new generation electric car and owns
            different models based on exclusive new energy platform. ORA brand
            was officially launched with its first model ORA iQ on August 20,
            2018. ORA R1 was launched On December 26 of the same year.
          </p>
          <button>KNOW MORE</button>
          <el-col :span="6"><div class="rightround"></div></el-col>
        </div>
        <div class="grid-content leftbox"></div>
      </el-col>
      <div class="car-video">
        <video :src="videoSrc" loop="loop" muted="muted" ref="video"></video>
        <div class="action" v-show="isShow">
          <img src="@/assets/images/play.png" @click="playVideo" />
        </div>
      </div>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "brand-lifestyle",
  props: {
    videoSrc: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isShow: true,
    };
  },
  methods: {
    playVideo() {
      this.$refs.video.play();
      this.isShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 1921px) {
  .title {
    font-size: 90px;
  }
}
// pc
@media screen and (min-width: 768px) {
  .lifestylebox {
    height: 820px;
    margin-bottom: 5%;
    overflow: hidden;
  }
  .title {
    position: absolute;
    width: 599px;
    height: 154px;
    // font-family: Source Han Sans SC;
    font-style: normal;
    font-weight: 900;
    font-size: 50px;
    line-height: 90px;
    left: calc(50% - 290px);
    color: #333333;
    top: 4%;
  }
  .text {
    position: absolute;
    width: 884px;
    height: 241px;
    left: calc(50% - 884px / 2 + 10px);
    top: calc(14%);
    // font-family: Source Han Sans SC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    text-align: center;
    color: #555555;
  }
 .fontstyle {
    text-overflow: clip !important;
  }
  .fontstyle button {
    position: absolute;
    width: 211px;
    height: 64px;
    left: calc(50% - 100px);
    top: calc(28%);
    background: #13b0b9;
    color: #fff;
    border: none;
  }
  .grid-content {
    height: 380px;
    width: 84%;
    margin-top: 370px;
    left: calc(29%);
  }
  .leftbox {
    background: #e35215;
    position: relative;
  }
  .car-video {
    width: 65%;
    height: 380px;
    background: transparent;
    left: calc(19%);
    top: calc(42%);
    z-index: 999;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .car-video video {
    position: absolute;
    object-fit: fill;
    width: 97%;
    height: 100%;
  }
  .action {
    width: 100%;
    color: rgb(255, 255, 255);
    position: absolute;
  }
  .action img {
    width: 70px;
    cursor: pointer;
  }
  .rightround {
    position: absolute;
    z-index: -99;
    width: 60%;
    height: 100%;
    right: 0%;
    left: calc(66%);
    background: #B7C1B1;
    border-radius: 50%;
  }
}
// 显示小屏幕样式
@media screen and (max-width: 767px) {
  .lifestylebox {
    height: 540px;
    margin: 10% 0;
    overflow: hidden;
  }
  .title {
    position: absolute;
    width: 194px;
    height: 36px;
    left: 25px;
    // font-family: Source Han Sans SC;
    font-style: normal;
    font-weight: 900;
    font-size: 36px;
    line-height: 36px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    color: #333333;
  }
  .text {
    position: absolute;
    width: 317px;
    height: 60px;
    left: calc(6%);
    top: calc(13%);
    // font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    text-align: justify;
    text-transform: capitalize;
    color: #555555;
  }
  .fontstyle button {
    position: absolute;
    top: calc(36%);
    left: 6%;
    background: #13b0b9;
    color: #fff;
    border: none;
    width: 140px;
    height: 40px;
  }
  .grid-content {
    height: 178px;
    right: calc(-20.5%);
    margin-top: 300px;
  }
  .leftbox {
    background: #e35215;
    position: relative;
    width: 350px;
  }

  .car-video {
    width: 86%;
    height: 173px;
    background: transparent;
    left: calc(6%);
    top: calc(50%);
    z-index: 999;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .car-video video {
    position: absolute;
    object-fit: fill;
    width: 100%;
    height: 100%;
  }
  .action {
    width: 100%;
    color: rgb(255, 255, 255);
    position: absolute;
  }
  .action img {
    width: 28.57px;
    cursor: pointer;
  }
  .rightround {
    position: absolute;
    z-index: -99;
    width: 340px;
    height: 340px;
    right: 0%;
    text-overflow: clip;
    top: 36%;
    left: calc(66%);
    background: #B7C1B1;
    border-radius: 50%;
  }
}
</style>